import { Injectable } from "@angular/core";
import { ApiService } from "../api.service";
import { TemplateDTO } from "../signals/signals.service";

const PATH = "signal-templates";

@Injectable({
  providedIn: "root",
})
export class SignalTemplateHandlerService {
  constructor(private apiService: ApiService) {}

  signalTemplatesGet(
    masterAccountID: number,
    queryParams?: { page?: number; perPage?: number },
  ) {
    return this.apiService.get(`${PATH}/${masterAccountID}`, {
      params: queryParams,
    });
  }

  signalTemplatGet(masterAccountID: number, templateID: number) {
    return this.apiService.get(`${PATH}/${masterAccountID}/${templateID}`);
  }

  signalTemplatePreviewPost(masterAccountID: number, previewDTO: any) {
    return this.apiService.post(
      `${PATH}/${masterAccountID}/preview`,
      previewDTO,
    );
  }

  signalTemplateDelete(masterAccountID: number, templateID: string) {
    return this.apiService.delete(`${PATH}/${masterAccountID}/${templateID}`);
  }

  signalTemplatePost(masterAccountID: number, template: TemplateDTO) {
    return this.apiService.post(`${PATH}/${masterAccountID}`, template);
  }

  signalTemplatePut(
    masterAccountID: number,
    templateID: string,
    template: TemplateDTO,
  ) {
    return this.apiService.put(
      `${PATH}/${masterAccountID}/${templateID}`,
      template,
    );
  }
}
